import React from "react";
import { Link, Navigate, useSearchParams } from "react-router-dom";
import FormsPage from "./Forms";
import { useI18n } from "@/contexts/I18nContext";
import Ref from "@/components/Ref";
import { ExternalLink } from "lucide-react";

// Batch 33 · B33-1 (owner decision): "Completion forms" shows the forms only — the final analytical review is its own sidebar
// item (/final-analytical-review); the old tab link /completion?view=far redirects there.
export default function Completion() {
  const { t } = useI18n();
  const [params] = useSearchParams();
  if (params.get("view") === "far") return <Navigate to="/final-analytical-review" replace />;
  return (
    <div className="space-y-4">
      {/* Batch A4 · R7 — 209(a) is the SAME instance stored at Risk
           Assessment. This banner links to that instance so the
           Completion team files the Final evaluation and conclusion
           without creating a duplicate form. */}
      <div className="rounded-md border border-emerald-200 bg-emerald-50/60 px-3 py-2 text-xs dark:border-emerald-900 dark:bg-emerald-950/20"
           data-testid="completion-a4-link">
        <span className="font-semibold text-emerald-900 dark:text-emerald-200">
          {t("completion.a4.seeAlso")}
        </span>{" "}
        <Link to="/planning?openForm=going_concern_events_and_conditions&highlight=4_final_evaluation_and_conclusion"
              className="inline-flex items-center gap-1 underline hover:text-emerald-800 dark:hover:text-emerald-200"
              data-testid="completion-a4-open-209a">
          <Ref>209(a)</Ref> {t("completion.a4.finalEval")} <ExternalLink className="h-3 w-3" />
        </Link>
      </div>
      <FormsPage tabId="completion" />
    </div>
  );
}
